import { useRef } from 'react';

import axios from 'axios';

export function useSchedulerServerClient({
    baseUrl
}) {

    const controllerRef = useRef(new AbortController());

    // const cancel = () => {
    //     controllerRef.current.abort();
    // };

    // const getAuthorization = (token) => {
    //     if (!token) return "";

    //     return `Bearer ${token}`
    // }

    const createAxiosInstance = ({ baseUrl }) => {
        return axios.create({
            baseURL: baseUrl,
            timeout: 30000,
            // method: "no-cors"
        })
    }

    // const getError = (status, message = '') => (
    //     {
    //         status,
    //         message
    //     }
    // )

    // const getSuccess = (status, message = '', data, warning) => (
    //     {
    //         status,
    //         message,
    //         data,
    //         warning
    //     }
    // )

    // const parseResponse = (response) => {

    //     // header header status
    //     if (isRequestSuccess(response) === false) {
    //         // throw new Error(`Server Failed`)
    //         throw getError(false, `Server Failed`)
    //     }

    //     // check header status
    //     if (isResultSuccess(response) === false) {
    //         // throw new Error(`${response?.data?.message}`)
    //         throw getError(false, `${response?.data?.message}`)
    //     }

    //     const { status, message, data, warning } = response?.data ? response.data : {}

    //     return getSuccess(Boolean(status), message, data, warning);

    // }

    // const isRequestSuccess = (response) => {
    //     if (response.status === 200) {
    //         return true;
    //     }
    //     return false;
    // }

    // const isResultSuccess = (response) => {
    //     if (response?.data?.status) {
    //         return true;
    //     }
    //     return false;
    // }

    const serverClient = useRef(
        createAxiosInstance({
            baseUrl
        })
    );

    const makeCall = async ({ url, payload, method }) => {

        const headers = {
            // 'X-Custom-Header': 'foobar'
            // "Authorization": getAuthorization(),
            'Content-Type': 'application/json',
            // 'AA': JSON.stringify(authData)
            // 'Access-Control-Allow-Headers': 'Content-Type,Authorization',
            // 'Access-Control-Allow-Origin': '*',
            // 'Access-Control-Allow-Methods': 'POST, PUT, PATCH, GET, DELETE, OPTIONS',
            // 'Access-Control-Request-Headers': '*',
            // 'Access-Control-Request-Method' : 'POST, PUT, PATCH, GET, DELETE, OPTIONS',
            // 'Access-Control-Allow-Credentials': "true",
            // 'X-Atlassian-Token': 'nocheck',
        };

        // if (authData?.token) {
        //     headers.Authorization = getAuthorization(authData?.token)
        // }

        // console.table(url, JSON.stringify(payload))

        const response = await serverClient.current.request(
            {
                data: payload,
                signal: controllerRef.current.signal,
                method,
                url,
                headers
            }
        );

        // console.table(url, JSON.stringify(payload))

        // return parseResponse(response);

        return response?.data
    }

    return {
        makeCall,
        // getError 
    }
}